import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Confirmer, CONFIRMER } from '@shared/components/dialogs/confirm/types';
import { UserGroupFilters } from '@/app/platform/platform-management/user-group-block/components/user-groups-filter/user-groups-filter.component';
import { UserGroupEntity } from '@/app/platform/platform-data/models/user-group.entity';
import { USER_GROUP_ACTIONS, UserGroupActions } from '@/app/platform/platform-data/actions/types';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
    selector: 'user-groups-list[activeItem][userGroups]',
    templateUrl: './user-groups-list.component.html',
    styleUrls: ['./user-groups-list.component.css'],
    standalone: false
})
export class UserGroupsListComponent {
  @Input() userGroups: UserGroupEntity[];
  @Input() activeItem: UserGroupEntity;
  @Input() loading: boolean;

  @Output() ngSelect = new EventEmitter<UserGroupEntity>();
  @Output() filter = new EventEmitter<UserGroupFilters>();


  constructor(
    @Inject(USER_GROUP_ACTIONS)
    private readonly userGroupActions: UserGroupActions,
    @Inject(CONFIRMER)
    private readonly confirmer: Confirmer
  ) {}

  activeApp = EgiAppEntity.createDefault();

  editDialogOpened = false;
  groupToEdit: UserGroupEntity = UserGroupEntity.createDefault();
  isUpdating = false;

  createDialogOpened = false;
  newGroup = UserGroupEntity.createDefault();
  isCreating = false;
  searchText = '';
  filtersOpened = false;
  activeFilters: UserGroupFilters = new UserGroupFilters();

  get filteredGroups(): UserGroupEntity[] {
    return this.userGroups
      .filter(g => {
        const { user } = this.activeFilters;
        if (!user) {
          return true;
        }

        return g.hasMember(user);
      })
      .filter(g => {
        const { app } = this.activeFilters;
        if (!app) {
          return true;
        }

        return g.hasAccessTo(app.rootNavigationItem);
      });
  }

  async onDelete(group: UserGroupEntity) {
    const confirmation = await this.confirmer.confirm(
      'Ben je zeker dat je deze group wil verwijderen?'
    );
    if (confirmation) {
      const result = await this.userGroupActions.delete(group);
      this.ngSelect.emit(UserGroupEntity.createDefault());
    }
  }

  openEditDialog(group: UserGroupEntity) {
    this.groupToEdit = group.clone();
    this.editDialogOpened = true;
  }

  async onEditSubmit(group: UserGroupEntity) {
    this.isUpdating = true;
    const result = await this.userGroupActions.update(group);
    this.isUpdating = false;
    result.ifSuccess(() => {
      this.editDialogOpened = false;
    });
  }

  openCreateDialog(): void {
    this.newGroup = UserGroupEntity.createDefault();
    this.createDialogOpened = true;
  }

  async onCreateSubmit(group: UserGroupEntity) {
    this.isCreating = true;
    const result = await this.userGroupActions.create(group);
    this.isCreating = false;
    result.ifSuccess(g => {
      this.createDialogOpened = false;
      this.ngSelect.emit(g);
    });
  }

  onFilter(filters: UserGroupFilters) {
    this.activeFilters = filters;
    this.filter.emit(filters);

    if (!this.filteredGroups.includes(this.activeItem)) {
      this.ngSelect.emit(UserGroupEntity.createDefault());
    }
  }
}
